$(document).on('turbolinks:load',function() {
    $('.form_reset').on('click',function(){
        $('.input_txt').val('');
    })
});
